<dx-popup
  #popup
  [fullScreen]="false"
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [title]="popupTitle"
  width="700"
  height="auto"
  [maxWidth]="'95vw'"
  [maxHeight]="'90vh'"
  [wrapperAttr]="{ class: 'kalender-termin-popup-wrapper' }"
  (onHidden)="onPopupHidden($event)"
>
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView height="100%">
      <dx-form #form [width]="'100%'" [formData]="formData" labelLocation="top" [colCount]="2">
        <dxi-item dataField="text" [label]="{ text: 'Betreff' }" [colSpan]="2">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="startDate" editorType="dxDateBox" [label]="{ text: 'Start' }" [editorOptions]="startDateEditorOptions">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'Ende' }" [editorOptions]="endDateEditorOptions">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item
          dataField="allDay"
          editorType="dxCheckBox"
          [label]="{ visible: false }"
          [editorOptions]="{ text: 'Ganztägig', onValueChanged: onAllDayValueChanged }"
          [colSpan]="2"
        >
        </dxi-item>

        <dxi-item dataField="location" [label]="{ text: 'Ort' }" [colSpan]="2"> </dxi-item>

        <dxi-item
          dataField="description"
          editorType="dxTextArea"
          [label]="{ text: 'Beschreibung' }"
          [editorOptions]="{ maxLength: 4000, height: 150 }"
          [colSpan]="2"
        >
        </dxi-item>
      </dx-form>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="before"
    toolbar="bottom"
    [options]="{
      visible: !isNew,
      text: 'Löschen',
      type: 'default',
      stylingMode: 'contained',
      icon: 'trash',
      disabled: isLoading,
      onClick: onClickDelete,
    }"
  >
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: isNew ? 'Anlegen' : 'Speichern',
      type: 'default',
      stylingMode: 'contained',
      icon: 'check',
      disabled: isLoading,
      onClick: onClickSave,
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{ text: 'Abbrechen', type: 'default', stylingMode: 'contained', icon: 'remove', disabled: isLoading, onClick: onClickClose }"
  >
  </dxi-popup-toolbar-item>
</dx-popup>
